export default __webpack_public_path__ + "static/media/Cream.b16ddc19.jpg";